import { AsyncActionHandler } from 'action-handler';
import { setOsPermission } from 'actions/gallery';

export default new AsyncActionHandler({
  name: 'fetch_os_permission',
  handler: (permissionType) => async (dispatch) => {
    const { status } = await window.__webview_comms__.get(
      'os-permission-status',
      {
        osPermissionType: permissionType
      }
    );

    dispatch(setOsPermission(permissionType, status));
  }
});
